import React from 'react'
import {
	createBrowserRouter
} from 'react-router-dom'
import LangLayout from '../components/LangLayout.tsx'
// Pages
import Home from '../pages/hr/home/index.tsx'
import Admin from '../pages/hr/admin/index.tsx'
import Dashboard from '../pages/hr/dashboard/index.tsx'
import Partners from '../pages/hr/partners/index.tsx'
import Price from '../pages/hr/price/index.tsx'
import Demo from '../pages/hr/demo/index.tsx'
import WeddingPlaner from '../pages/hr/weddingPlaner/index.tsx'
import WeddingPlanerLanding from '../pages/hr/weddingPlanerLanding/index.tsx'
import WeddingPlanerLogin from '../pages/hr/weddingPlanerLogin/index.tsx'
import WeddingPlanerRegister from '../pages/hr/weddingPlanerRegister/index.tsx'
import Unsubscribe from '../pages/hr/unsubscribe/index.tsx'
import TermsAndConditions from '../pages/legal/terms-conditions.tsx'
import PrivacyPolicy from '../pages/legal/privacy-policy.tsx'
import RefundPolicy from '../pages/legal/refund-policy.tsx'
import Rsvp from '../pages/rsvp/index.tsx'
import NotFound from '../pages/notFound.tsx'

// Blog nosi sadržaj svih 6 jezika (~47 kB gzip). Lazy import ga drži izvan
// glavnog bundlea, pa posjetitelji naslovnice ne plaćaju tekstove članaka.
// Fallback ne treba dodavati — LangLayout već omata <Outlet /> u <Suspense>.
const BlogList = React.lazy(() => import('../pages/blog/index.tsx'))
const BlogPost = React.lazy(() => import('../pages/blog/post.tsx'))
const PhotoApp = React.lazy(() => import('../pages/photoApp/index.tsx'))

// Routes without language prefix (default Croatian)
const baseRoutes = [
	{ index: true, element: <Home /> },
	{ path: 'price', element: <Price /> },
	{ path: 'demo', element: <Demo /> },
	{ path: 'wedding-photo-app', element: <PhotoApp /> },
	{ path: 'admin', element: <Admin /> },
	{ path: 'admin/dashboard', element: <Dashboard /> },
	{ path: 'admin/dashboard/partners', element: <Partners /> },
	{ path: 'weddingPlanner', element: <WeddingPlanerLanding /> },
	{ path: 'weddingPlanner/login', element: <WeddingPlanerLogin /> },
	{ path: 'weddingPlanner/register', element: <WeddingPlanerRegister /> },
	{ path: 'unsubscribe', element: <Unsubscribe /> },
	{ path: 'weddingPlanner/:plannerId', element: <WeddingPlaner /> },
	{ path: 'blog', element: <BlogList /> },
	{ path: 'blog/:slug', element: <BlogPost /> },
	{ path: 'rsvp/:token', element: <Rsvp /> },
	{ path: 'privacy-policy', element: <PrivacyPolicy /> },
	{ path: 'terms-and-conditions', element: <TermsAndConditions /> },
	{ path: 'refund-policy', element: <RefundPolicy /> },
	{ path: '*', element: <NotFound /> }
]

export const router = createBrowserRouter([
	// Routes with language prefix (e.g., /en, /de, /sr)
	{
		path: '/:lang',
		element: <LangLayout />,
		children: baseRoutes
	},
	// Default routes without language prefix (Croatian)
	{
		path: '/',
		element: <LangLayout />,
		children: baseRoutes
	},
	// Catch-all fallback
	{
		path: '*',
		element: <LangLayout />,
		children: [
			{ path: '*', element: <NotFound /> }
		]
	}
])
